import {
	Box,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
} from "@mui/material";
import React, { useState } from "react";
import CommCard from "src/common/CommCard";
import { CommonPagination } from "src/common/CommonPagination";
import ModalsWrapper from "src/components/Modals/ModalsWrapper";
import { useGetQueryWithTotal } from "src/hooks/useGetQueryWithTotal";
import type { IRafflePrize } from "src/Types/module/raffleDraw/raffleDraw";
import { TableLoader, TableNotFound } from "src/Utils/TableLoader";
import PrizeFormModal from "./PrizeFormModal";
import PrizeTableRow from "./PrizeTableRow";

const PrizeList: React.FC = () => {
	const [pagination, setPagination] = useState({ limit: 50, skip: 0 });
	const [search, setSearch] = useState("");

	const [openModal, setOpenModal] = useState(false);
	const [selectedPrize, setSelectedPrize] = useState<IRafflePrize | null>(null);

	const { data, isLoading } = useGetQueryWithTotal<IRafflePrize[]>({
		endPoint: "/api/raffle-draw/prize",
		queryKeys: ["raffle-prize", search, pagination.skip, pagination.limit],
		params: {
			...pagination,
			search: search || undefined,
		},
	});

	const handleOpenCreate = () => {
		setSelectedPrize(null);
		setOpenModal(true);
	};

	const handleOpenEdit = (prize: IRafflePrize) => {
		setSelectedPrize(prize);
		setOpenModal(true);
	};

	const handleCloseModal = () => {
		setOpenModal(false);
		setSelectedPrize(null);
	};

	return (
		<>
			<CommCard
				showCardHeader
				headerTitle={`Prize List (${data?.total || 0})`}
				helmetTitle="BTTF - Raffle Draw Prize List"
				showButton
				btnText="Create Prize"
				handleBtnForModalFun={handleOpenCreate}
				showSearch
				handleSearchFun={(val) => {
					setSearch(val);
					setPagination((prev) => ({ ...prev, skip: 0 }));
				}}
			>
				<TableContainer>
					<Table>
						<TableHead>
							<TableRow>
								<TableCell>SL.</TableCell>
								<TableCell>Prize No.</TableCell>
								<TableCell>Prize Details</TableCell>
								<TableCell>Status</TableCell>
								<TableCell>Winner Details</TableCell>
								<TableCell>Prize Given</TableCell>
								<TableCell>Created At</TableCell>
								<TableCell>Actions</TableCell>
							</TableRow>
						</TableHead>

						{isLoading ? (
							<TableLoader />
						) : data?.data && data.data.length > 0 ? (
							<TableBody>
								{data.data.map((prize, idx) => (
									<PrizeTableRow
										key={prize.id}
										prize={prize}
										serial={idx + 1 + pagination.skip}
										onEdit={handleOpenEdit}
									/>
								))}
							</TableBody>
						) : (
							<TableNotFound />
						)}
					</Table>
				</TableContainer>

				<Box p={2}>
					<CommonPagination
						total={data?.total}
						paginationCalFun={(limit: number, skip: number) => {
							setPagination({ limit, skip });
						}}
					/>
				</Box>
			</CommCard>

			<ModalsWrapper
				showModal={openModal}
				setShowModal={setOpenModal}
				modalData={{
					title: selectedPrize ? "Edit Prize" : "Create Prize",
				}}
				maxWidth="xs"
			>
				<PrizeFormModal
					prize={selectedPrize}
					handleClose={handleCloseModal}
				/>
			</ModalsWrapper>
		</>
	);
};

export default PrizeList;
